import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useThemeMode } from '../shared/ThemeModeContext';
import { type FuelThemeMode } from '@deere/fuel-react/useFuelTheme.js';

export const ThemeModeSelect = () => {
  const { preference, setPreference } = useThemeMode();

  return (
    <FormControl size="small" sx={{ minWidth: 60 }}>
      <Select
        value={preference}
        onChange={(e) => setPreference(e.target.value as FuelThemeMode)}
        inputProps={{ 'aria-label': 'Theme mode' }}
      >
        <MenuItem value="system">System</MenuItem>
        <MenuItem value="light">Light</MenuItem>
        <MenuItem value="dark">Dark</MenuItem>
      </Select>
    </FormControl>
  );
};
